import React from 'react';
import { useMemo, useState } from 'react';
import { useMatch } from 'react-router-dom';

import TitleBox from '../../components/title_box/title_box';
import CaseSteps from '../../components/case_steps/case_steps';
import PageBanner from '../../components/page_banner/page_banner';
import CaseCard from '../../components/case_card/case_card';
import AskFooter from '../../components/ask_footer/ask_footer';

import { solutions, uses } from '../../data/case';

import styles from './case.module.css';

const Case = () => {
  const match = useMatch('/case/:type');
  const { type: pageTab } = match.params;

  const pageName = useMemo(() => {
    return pageTab === 'catering'
      ? '요식업'
      : pageTab === 'spicy_hot_pot'
      ? '마라탕'
      : '무인매장';
  }, [pageTab]);

  const solutionContents = solutions[pageTab];
  const usesContents = uses[pageTab];

  const malaImgPath =
    process.env.PUBLIC_URL + '/imgs/case/spicy_hot_pot/mala_program';
  const malaTabletImgPath = malaImgPath + '_tablet';
  const malaMobileImgPath = malaImgPath + '_mobile';

  return (
    <div className={styles.container}>
      <PageBanner type={match.pathname} />

      <div className={styles.contentsContainer}>
        <section>
          <TitleBox
            text={'유연한 연동과 차별화된 솔루션,'}
            strong={`우노스 ${pageName} 프로그램은 어떻게 사용하나요?`}
          />

          {pageTab !== 'spicy_hot_pot' ? (
            <CaseSteps type={pageTab} />
          ) : (
            <picture className={styles.imgStepBox}>
              <source
                media='(max-width: 480px)'
                srcSet={malaMobileImgPath + '.png'}
              />
              <source
                media='(max-width: 768px)'
                srcSet={malaTabletImgPath + '.png'}
              />

              <img src={malaImgPath + '.png'} alt='' />
            </picture>
          )}

          {pageTab !== 'catering' && (
            <div className={styles.videoWrapper}>
              <Video pageTab={pageTab} />
            </div>
          )}
        </section>

        <section>
          <TitleBox
            text='결제 솔루션으로 매장 운영을 편리하게,'
            strong={`우노스 ${pageName} 프로그램은 어떤점이 좋은가요?`}
          />

          {solutionContents &&
            solutionContents.map((content, index) => (
              <CaseCard key={index} content={content} type={pageTab} />
            ))}
        </section>

        {usesContents && (
          <section>
            <TitleBox
              text='다양하게 응용 가능한,'
              strong={`우노스 ${pageName} 프로그램 이렇게 활용해보세요!`}
            />

            <div className={styles.cards}>
              {usesContents.map((use, index) => (
                <CaseCard key={index} content={use} type={pageTab} isVertical />
              ))}
            </div>
          </section>
        )}
      </div>

      <AskFooter />
    </div>
  );
};

export default Case;

const Video = ({ pageTab }) => {
  const [videoInfo, setVideoInfo] = useState(false);
  const poster = process.env.PUBLIC_URL + `/imgs/case/${pageTab}/poster.png`;
  const src = process.env.PUBLIC_URL + `/imgs/case/${pageTab}/manual.mp4`;

  return (
    <>
      <video
        controls
        playsinline
        muted
        preload='none'
        poster={poster}
        src={src}
        onPlay={() => setVideoInfo(false)}
        onEnded={() => setVideoInfo(true)}
      >
        {/* <source type='video/mp4' src={src} /> */}
      </video>

      {pageTab === 'unmanned' && (
        <div
          style={{ display: videoInfo ? 'block' : 'none' }}
          className={styles.videoInfo}
        >
          Song : Simon More - Happy Vibes
          <br />
          Follow Artist : soundcloud.com/user-73416670
          <br />
          Music Download Link [DayDreamSound] : https://youtu.be/wma3UyNMDQY
        </div>
      )}
    </>
  );
};
